import store from '@/store'
import navigation from '@/navigation'

store.dispatch('navigation/setNavItems', {navItems: navigation})
